export default ({request}) => ({
  ecomAmzStoreListApi(data = {}) {
    return request({
      url: '/ecom/amz/store/list',
      method: 'post',
      data,
    })
  },
  ecomAmzStoreDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/store/detail',
      method: 'post',
      data,
    })
  },
  ecomAmzStoreSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/store/save',
      method: 'post',
      data,
    })
  },
  ecomAmzStoreDelApi(data = {}) {
    return request({
      url: '/ecom/amz/store/del',
      method: 'post',
      data,
    })
  },
})
